// extracted by mini-css-extract-plugin
export default {"expandableBlock":"DiagnosticList_expandableBlock__y1a3f","title":"DiagnosticList_title__6MqJH","errorCountBadge":"DiagnosticList_errorCountBadge__d4W6T"};